export const PAGINATION = {
    CABINET: 'cabinet',
    CAR_MAIN_PAGE: 'mainCar',
    BIKE_MAIN_PAGE: 'mainBike',
    COMMERCIAL_MAIN_PAGE: 'mainCommercial',
    DEALER_CAR_LIST: 'dealerCarAllList',
    DEALER_BIKE_LIST: 'dealerBikeAllList',
    DEALER_COMMERCIAL_LIST: 'dealerCommercialAllList',
    SELL_CAR_CABINET_LIST: 'sellCarCabinetList',
    SELL_BIKE_CABINET_LIST: 'sellBikeCabinetList',
    SELL_COMMERCIAL_CABINET_LIST: 'sellCommercialCabinetList',
    SELL_CAR_LIST: 'sellCarAllList',
    SELL_BIKE_LIST: 'sellBikeAllList',
    SELL_COMMERCIAL_LIST: 'sellCommercialAllList',
    SELL_CAR_FORM: 'sellCarForm',
    SELL_CAR_PRO_FORM: 'sellCarProForm',
    SELL_BIKE_FORM: 'sellBikeForm',
    SELL_BIKE_PRO_FORM: 'sellBikeProForm',
    SELL_COMMERCIAL_FORM: 'sellCommercialForm',
    SELL_COMMERCIAL_PRO_FORM: 'sellCommercialProForm',
    TOP_DEALER_LIST: 'topDealerAllList',
    TOP_SERVICES_LIST: 'topServicesAllList',
    TOP_PLACEMENT_LIST: 'topPlacementAllList',
    TOP_PARTS_LIST: 'topPartsAllList',
    TOP_COMPANY_LIST: 'topCompanyAllList',
    TOP_CAR_LIST: 'topCarAllList',
    TOP_RENT_LIST: 'topRentAllList',
    TOP_BIKE_LIST: 'topBikeAllList',
    TOP_COMMERCIAL_LIST: 'topCommercialAllList',
    RENT_CAR_LIST: 'rentCarAllList',
    RENT_CAR_FORM: 'rentCarForm',
    RENT_CAR_CABINET_LIST: 'rentCarCabinetList',
    RENT_BIKE_LIST: 'rentBikeAllList',
    RENT_BIKE_FORM: 'rentBikeForm',
    RENT_BIKE_CABINET_LIST: 'rentBikeCabinetList',
    RENT_COMMERCIAL_LIST: 'rentCommercialAllList',
    RENT_COMMERCIAL_FORM: 'rentCommercialForm',
    RENT_COMMERCIAL_CABINET_LIST: 'rentCommercialCabinetList',
    SERVICES_FORM: 'servicesForm',
    SERVICES_ALL_LIST: 'servicesAllList',
    SERVICES_CABINET_LIST: 'servicesCabinetList',
    PLACEMENT_FORM: 'placementForm',
    PLACEMENT_ALL_LIST: 'placementAllList',
    PLACEMENT_CABINET_LIST: 'placementCabinetList',
    PARTS_CAR_CABINET_LIST: 'partsCarCabinetList',
    PARTS_BIKE_CABINET_LIST: 'partsBikeCabinetList',
    PARTS_COMMERCIAL_CABINET_LIST: 'partsCommercialCabinetList',
    PARTS_CABINET_LIST: 'partsCabinetList',
    PARTS_CAR_LIST: 'partsCarAllList',
    PARTS_BIKE_LIST: 'partsBikeAllList',
    PARTS_COMMERCIAL_LIST: 'partsCommercialAllList',
    PARTS_ALL_LIST: 'partsAllList',
    PARTS_FORM: 'partsForm',
    PARTS_COMPANY_LIST: 'partsCompanyList',
    SERVICES_COMPANY_LIST: 'servicesCompanyList',
    COMPANY_FORM: 'companyForm',
    COMPANY_ALL_LIST: 'companyAllList',
    COMPANY_CABINET_LIST: 'companyCabinetList',
    COMPANY_EXPERT_ALL_LIST: 'companyExpertAllList',
    FAVORITES_CAR: 'favoritesCarList',
    FAVORITES_BIKE: 'favoritesBikeList',
    FAVORITES_COMMERCIAL: 'favoritesCommercialList',
    FAVORITES_PARTS: 'favoritesPartsList',
};

export const SEARCH_PAGE_SIZE = 10;
